import AddIcon from '@mui/icons-material/Add';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { strings } from '../../resources/strings/strings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { clearUserDataAction } from '../../store/user/UserActionCreators';
import { getUserTypeProfileUrl, UserTypes } from '../../store/user/UserHelpers';
import { UserModel } from '../../store/user/UserModel';
import { userSelector } from '../../store/user/UserSelectors';
import { clearAuthData } from '../../utils/axiosConfig';
import './UserMenu.scss';

export const UserMenu = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user: UserModel = useAppSelector(userSelector);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const isDesktop = useMediaQuery('(min-width:769px)');

  const userType = localStorage.getItem('userType');

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    clearAuthData();
    dispatch(clearUserDataAction());

    navigate('/login');

    setAnchorElUser(null);
  };

  const handleGoToProfile = () => {
    if (userType) {
      navigate(getUserTypeProfileUrl(userType));
    } else {
      clearAuthData();
      dispatch(clearUserDataAction());
      navigate('/login');
    }

    setAnchorElUser(null);
  };

  return (
    <Box sx={{ flexGrow: 0 }}>
      {isDesktop && (
        <Button size='small' variant='outlined' color='secondary' onClick={() => navigate('/partners')} sx={{ mr: 2 }}>
          {strings.res_ownersOfSpace}
        </Button>
      )}
      {userType !== UserTypes.NORMAL ? (
        <Button
          className='add-place-button'
          size='small'
          startIcon={<AddIcon />}
          onClick={() => navigate('/listing-form')}
          variant='contained'
        >
          {strings.res_addPlace}
        </Button>
      ) : (
        <></>
      )}
      <IconButton size='large' onClick={handleOpenUserMenu} sx={{ p: 0 }}>
        <Avatar alt={`${user.firstName} ${user.lastName}`} src='' />
      </IconButton>
      <Menu
        className='menu-user'
        sx={{ mt: '45px' }}
        id='menu-appbar'
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <MenuItem className='user-menu-item' onClick={handleGoToProfile}>
          <Typography textAlign='center'>{strings.res_myProfile}</Typography>
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <Typography textAlign='center'>{strings.res_logout}</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};
